module.exports = __webpack_public_path__ + "static/media/SellerCentral.a66bd97b.svg";